module.exports = __webpack_public_path__ + "static/static-video.6af16671.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/static-video.png
// module id = 1948
// module chunks = 35783957827783